// Pure helpers for the interactive DPD login page (unit-tested).

export const SPECIAL_KEYS = new Set([
  "Enter", "Tab", "Backspace", "Delete", "Escape", "ArrowUp", "ArrowDown",
  "ArrowLeft", "ArrowRight", "Home", "End", "PageUp", "PageDown",
]);

const clamp01 = (v) => Math.min(1, Math.max(0, v));

// The <img> uses object-contain, so the frame may be letterboxed inside the
// element; map against the area where the frame is actually drawn.
export function containedRect(rect, frameW, frameH) {
  if (!rect || !frameW || !frameH) return rect;
  const scale = Math.min(rect.width / frameW, rect.height / frameH);
  const width = frameW * scale;
  const height = frameH * scale;
  return { left: rect.left + (rect.width - width) / 2, top: rect.top + (rect.height - height) / 2, width, height };
}

export function normalizePoint(clientX, clientY, rect, frameW, frameH) {
  rect = containedRect(rect, frameW, frameH);
  if (!rect || rect.width <= 0 || rect.height <= 0) return null;
  return {
    x: Number(clamp01((clientX - rect.left) / rect.width).toFixed(4)),
    y: Number(clamp01((clientY - rect.top) / rect.height).toFixed(4)),
  };
}

export function buildWsUrl(apiBase, wsPath, sessionId, viewport) {
  const base = new URL(apiBase, window.location.href);
  const proto = base.protocol === "https:" ? "wss:" : "ws:";
  const qs = new URLSearchParams({ session_id: sessionId, viewport });
  return `${proto}//${base.host}${wsPath}?${qs.toString()}`;
}

export function keyMessage(e) {
  if (e.key === "Tab" && e.shiftKey) return { t: "key", k: "Shift+Tab" };
  if (SPECIAL_KEYS.has(e.key)) return { t: "key", k: e.key };
  return null;
}

export function formatCountdown(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const m = String(Math.floor(total / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");
  return `${m}:${s}`;
}

// Mobile keyboards often don't emit Backspace keydown; we keep a one-char
// sentinel in the hidden input and diff against it instead.
export const SENTINEL = " ";
export function diffSentinel(value) {
  if (value.length < SENTINEL.length) return { t: "key", k: "Backspace" };
  const added = value.startsWith(SENTINEL) ? value.slice(SENTINEL.length) : value;
  return added ? { t: "text", v: added.slice(0, 256) } : null;
}

export function defaultViewport() {
  return typeof window !== "undefined" && window.innerWidth < 768 ? "mobile" : "desktop";
}
